import clsx from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export interface ProseProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  text: string;
}

export const Prose = forwardRef<HTMLDivElement, ProseProps>(function Prose(
  { className, text, ...attrs },
  ref,
) {
  if (!text) {
    return null;
  }

  return (
    <div
      {...attrs}
      className={clsx(className, 'prose')}
      dangerouslySetInnerHTML={{ __html: text }}
      ref={ref}
    />
  );
});
